<template>
 <div>
  <v-dialog
    :value="value"
    @input="$emit('input',$event)"
    width="400"
    >

      <v-card color="orange" dark>
        <v-card-title class="headline fill-width d-flex justify-space-between"><span class="d-inline-block">Get Now</span><v-btn icon @click="$emit('input',false)" class="d-inline-block"><v-icon size="24px" >mdi-close</v-icon></v-btn></v-card-title>
        <v-card-text class="pb-0">
          <v-container>
            <v-form ref="form">
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-text-field
                  label="name*"
                  :rules="rules.required"
                  v-model="contact.name"
                  outlined
                  dense
                  required
                ></v-text-field>
                <v-text-field
                  label="email"
                  type="email"
                  :rules="rules.email"
                  v-model="contact.email"
                  outlined
                  dense
                  required
                ></v-text-field>
                <v-text-field
                  label="phone number*"
                  :rules="rules.phoneNumber"
                  v-model="contact.phoneNumber"
                  outlined
                  dense
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" class="orange--text" @click="submit()">submit</v-btn>
        </v-card-actions>
      </v-card>
      
  </v-dialog>
  <v-dialog width="400" v-model="d">
  <v-card >
    <v-card-title>Thank you, </v-card-title>
    <v-card-text>
      we will reach to you within 24hrs. have a nice day.
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="orange" text @click="d=false">Ok</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
  <v-overlay :value="loading">
      <v-progress-circular indeterminate color="orange" size="64"></v-progress-circular>
    </v-overlay>
</div>
</template>
<script type="text/javascript">
import axios from 'axios'
  export default{
    props:['value'],
    data(){
      return {
        d:false,
        rules:{
          required:[v=>!!v || 'required'],
          email:[
              v => !!v || 'E-mail is required',
              v => /.+@.+/.test(v) || 'E-mail must be valid'
        ],
          phoneNumber:[v => !!v || 'Contact is required',v =>v&&v.match(/^[6-9]\d{9}$/) || 'Invalid Contact']
        },
        contact:{
          name:'',
          email:'',
          phoneNumber:''
        },
        loading:false
      }
    },
    methods:{
      submit(){
        if(this.$refs.form.validate())
        {
          this.loading=true
          this.$emit('input',false)
          axios.post('https://api.grocart.in/enquery',{contact:this.contact}).then(r=>{
            this.loading=false
            this.d=true
            console.log(r)
          })
        }
      }
    }
  }
</script>